// extracted by mini-css-extract-plugin
export default {"partyRow":"Menu_partyRow__Lajcw"};